@if (formGroup) {
	@if (getControl(); as control) {
		<div [formGroup]="formGroup" class="metabi-control">
			@if (!noLabel) {
				<app-field-label [for]="formGroupOrControlName">
					{{ getLabel() }}
				</app-field-label>
				<br />
			}
			<nz-select
				[formControl]="control"
				name="option"
				(ngModelChange)="onChange($event)"
				[nzMode]="multiple ? 'multiple' : 'default'"
			>
				@for (option of options; track option) {
					<nz-option [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
				}
			</nz-select>
			@if (control.errors && control.touched) {
				<app-field-error>
					{{ curateValidationHint(control) }}
				</app-field-error>
			}
		</div>
	}
}
